const LABEL = {
  PROCESS_DETAILS: {
    invoice: 'Detalii Factură',
    organisation: 'Detalii Organizație',
    partner: 'Detalii Partener',
    articles: 'Detalii Articole',
    totals: 'TOTALURI'
  },
  PROCESS_BUTTONS: {
    supportingDocuments: 'Documente Justificative',
    updateDocument: 'Actualizează',
    approveDocument: 'Aprobă',
    processDocument: 'Procesează document',
    sendToOMC: 'Trimite în OMC'
  },
  INVOICE_DETAILS: {
    issueDate: 'Dată Emitere',
    dueDate: 'Dată Scadentă',
    docInitialDate: 'Data Inițială Document',
    notes: 'Note'
  },
  ORGANISATION_PARTNER_DETAILS: {
    buyer: 'Cumpărător',
    seller: 'Vânzător',
    cif: 'CIF:',
    name: 'Nume:',
    address: 'Adresă:',
    postalCode: 'Cod Poștal',
    city: 'Oraș',
    county: 'Județ',
    country: 'Țara',
    group: 'Grupă Partener:'
  },
  LINE_BUTTONS: {
    deleteLine: 'Șterge linia'
  },
  LINE_DETAILS: {
    description: 'Descriere',
    measureUnit: 'UM',
    quantity: 'Cantitate',
    unitPriceWithoutVat: 'Preț Unitar (fără TVA)',
    vatPercentage: 'Cotă TVA',
    invoicePeriodStartDate: 'Dată Început Perioadă',
    invoicePeriodEndDate: 'Dată Sfârșit Perioadă',
    observations: 'Observații',
    article: 'Articol'
  },
  TVA_TOTALS: {
    totalWithoutVat: 'Total fără TVA',
    vatTotal: 'Total TVA',
    totalWithVat: 'Total cu TVA'
  },
  CURRENCIES: {
    ron: 'RON'
  },
  SUPPORTING_DOCUMENTS: {
    selectedFiles: (files) =>
      `${files.length} fișiere selectate, ${(
        files.reduce((sum, file) => sum + file.size, 0) /
        (1024 * 1024)
      ).toFixed(2)} MB / 25MB`,
    index: '#',
    name: 'Nume Document',
    fileSize: 'Mărime Fișier (MB)'
  },
  SUPPORTING_DOCUMENTS_BUTTONS: {
    deleteAll: 'Șterge Toate',
    zipDownload: 'Descarcă ZIP'
  },
  LOADING: {
    label: 'Se încarcă...'
  },
  PROCESS_TABLE_HEAD: {
    index: '#',
    series: 'Serie',
    uploadDate: 'Dată Încărcare',
    issueDate: 'Dată Emitere',
    dueDate: 'Dată Scadență',
    partnerName: 'Nume Partener',
    totalValue: 'Valoare Totală',
    documentNumber: 'Nr. Document',
    invoiceGroup: 'Grupă',
    status: 'Status',
    statusFilter: 'Filtreaza dupa status',
    organisation: 'Organizație',
    organisationFilter: 'Filtrează după organizație',
    deleteFilters: 'Șterge filtrele',
    exportDocuments: 'Exportă',
    categoryFilter: 'Filtrează după categorii',
    uploadIndex: 'Index Încărcare'
  },
  SPV_SYNC: {
    lastSync: 'Vezi ultima sincronizare cu SPV',
    organisation: 'Organizație',
    lastUpdate: 'Ultima actualizare SPV',
    indexedDocuments: 'Documente indexate'
  },
  ACTIONS: {
    label: 'Acțiuni'
  },
  EXPORTS: {
    xml: 'Export XML',
    pdf: 'Export PDF'
  },
  SPV_SYNC_STATUS: {
    label: 'Vezi ultima sincronizare cu SPV',
    organisation: 'Organizație',
    lastSync: 'Ultima actualizare SPV',
    indexDoc: 'Documente indexate'
  },
  SEARCH_TERM: {
    placeholder:
      'Căutare după index de încarcare, serie document, CIF/nume partener, CIF/nume organizație'
  },
  DOCUMENTS_PER_PAGE: {
    label: (size) => `${size} documente pe pagină`
  },
  ASCENDING: {
    label: 'ascending'
  },
  DESCENDING: {
    label: 'descending'
  },
  GENERIC_DROPDOWN: {
    label: 'Item',
    placeholder: 'Selecteaza un item'
  },
  ARTICLE_DROPDOWN: {
    label: 'Articol',
    placeholder: 'Selecteaza un articol'
  },
  COST_CENTER_DROPDOWN: {
    label: 'Centru de Cost',
    placeholder: 'Selecteaza un centru de cost'
  },
  EXPENSE_GROUP_DROPDOWN: {
    label: 'Grupă Cheltuială',
    placeholder: 'Selecteaza o grupa de cheltuială'
  },
  GROUP_DROPDOWN: {
    label: 'Grupă Factura',
    placeholder: 'Selecteaza un grup'
  },
  POW_DROPDOWN: {
    label: 'Punct de Lucru',
    placeholder: 'Selecteaza un punct de lucru'
  },
  PROJECTS_DROPDOWN: {
    label: 'Nr. Obiect',
    placeholder: 'Selecteaza un nr. obiect'
  },
  CATEGORIES_DROPDOWN: {
    label: 'Categorii',
    placeholder: 'Selecteaza o categorie'
  },
  DEPARTMENTS_DROPDOWN: {
    label: 'Departamente',
    placeholder: 'Selecteaza un departament'
  },
  PARTNER_DROPDOWN: {
    label: 'Partener',
    placeholder: 'Selecteaza un partner'
  },
  RULES_TABLE: {
    title: 'Adăugare Regula',
    addRuleButton: 'Adăugare',
    index: '#',
    partnerName: 'Nume Partener',
    pointOfWork: 'Punct de Lucru',
    category: 'Categorie',
    actions: 'Acțiuni',
    organisation: 'Organizație'
  },
  FILTER: {
    label: 'Filtreaza'
  },
  NO_ELEMENTS_SELECTED: {
    label: 'Niciun element selectat'
  },
  SEARCH: {
    label: 'Cautare...'
  },
  NEXT_PAGE: {
    label: 'Următoare'
  },
  PREVIOUS_PAGE: {
    label: 'Anterioară'
  },
  SELECTED_ELEMENTS: {
    label: 'Elemente Selectate'
  },
  DELETE: {
    label: 'Șterge'
  },
  EMPTY_FILTER: {
    label: 'Nicio înregistrare '
  },
  APPLY: {
    label: 'Aplică'
  },
  PARTNER: {
    label: 'Partener'
  },
  CLEAR_SELECTION: {
    label: 'Clear Selection'
  },
  EXCEL: {
    isDragging: 'Trageți fișierul excel aici...',
    isNotDragging: 'Trageți fișierul sau dați click pentru a selecta unul'
  },
  DOCUMENT_METADATA: {
    IMPORT_EXCEL: 'Importă Excel',
    DOWNLOAD_XML: 'XML',
    DOWNLOAD_ZIP: 'ZIP',
    EXPORT_EXCEL: 'Exportă Excel',
    DOWNLOAD_PDF: 'PDF',
    STATUS_HISTORY: 'Vezi istoric status document'
  },
  DOCUMENT_DATE: {
    label: 'Data Document'
  },
  MINIMUM_DATE: {
    label: 'Data minimă permisă:'
  },
  ZOOM: {
    in: 'Zoom In',
    out: 'Zoom Out',
    reset: 'Reset Zoom'
  },
  PREVIOUS_INVOICE_REFERENCE: {
    label: 'Referință factură anterioară'
  },
  ADD_LINE: {
    label: 'Adaugă linie'
  },
  PRICE_DIFFERNECE_TABLE: {
    document: 'Document SPV',
    processedDocument: 'Document Procesat',
    difference: 'Diferență',
  },
  ARTICLE_RULES_TABLE: {
    company: 'Companie',
    expenseGroup: 'Grup de cheltuieli',
    articleNumber: 'Număr articole',
    actions: 'Acțiuni',
  },
  DROPDOWN: {
    select: 'Selectează...',
  },
  ARTICLE_LIST_MODAL: {
    NO_ARTICLE_SEARCH: 'Niciun articol nu se potrivește căutării.',
    NO_ARTICLES: 'Nu există articole.',
  }
}

export default LABEL
